import { QrDisplayConfig } from "../types/qr-display-config";

export function isQrTypeAllowedForBranch(
  qrType: string,
  onlyRatings: boolean,
  googleLink?: string | null
): boolean {
  if (qrType === "TIP" && onlyRatings) {
    return false;
  }
  if (qrType === "TIP_GOOGLE" && !googleLink?.trim()) {
    return false;
  }
  return true;
}

export function filterQrConfigsForBranch(
  configs: QrDisplayConfig[],
  onlyRatings: boolean,
  googleLink?: string | null
): QrDisplayConfig[] {
  return configs.filter((config) =>
    isQrTypeAllowedForBranch(config.qrType, onlyRatings, googleLink)
  );
}

export function getQrDisplayFlags(
  qrType: string | null | undefined,
  options: { canShowTipQr: boolean; hasGoogleLink: boolean; onlyRatings?: boolean }
): { showTipQr: boolean; showRatingQr: boolean; showGoogleQr: boolean } {
  if (options.onlyRatings) {
    return {
      showTipQr: false,
      showRatingQr: true,
      showGoogleQr: false,
    };
  }

  const type = qrType || "TIP_RATING";
  return {
    showTipQr:
      options.canShowTipQr &&
      (type === "TIP" || type === "TIP_RATING" || type === "TIP_GOOGLE"),
    showRatingQr: type === "TIP_RATING" || (!qrType && !options.canShowTipQr),
    showGoogleQr: type === "TIP_GOOGLE" && options.hasGoogleLink,
  };
}
